import { h, Component } from 'preact';

import { joinClasses } from 'utils/utils';
import * as moment from 'moment-timezone';
import Link from 'components/bolt/link/link.js';

import s from 'components/shared/time/time.sss';

export default class Time extends Component {
	constructor(props) {
		super(props);
		this.flashUpdate = this.flashUpdate.bind(this);
		this.clockIntroUpdate = this.clockIntroUpdate.bind(this);
		this.updateTime = this.updateTime.bind(this);
		this.state = {
			ldn: [],
			la: [],
			flash: true,
			stop: false,
			clockIntro: 0
		};
	}

	componentDidMount() {
		this.updateTime();

		const canvas = this.$canvas;
		this.ctx = canvas.getContext('2d');
		canvas.width  = canvas.offsetWidth;
		canvas.height = canvas.offsetHeight;
		this.radius = canvas.height * 0.5;
		this.ctx.imageSmoothingEnabled = true;
	}

	componentWillReceiveProps(nextProps) {
		if (!this.props.active && nextProps.active) {
			this.init();
		}
		if (this.props.active && !nextProps.active) {
			this.setState({ clockIntro: 0 });
			clearTimeout(this.clockIntroTimer);
			clearTimeout(this.flashUpdate);
			// clearTimeout(this.timeTimer);
		}
	}

	componentDidUpdate(oldProps, oldState) {
		if (oldState.flash !== this.state.flash || oldState.clockIntro !== this.state.clockIntro) {
			this.drawClock();
		}
	}

	componentWillUnmount() {
		clearTimeout(this.clockIntroTimer);
		clearTimeout(this.flashUpdate);
		clearTimeout(this.timeTimer);
	}

	init() {
		this.clockIntroTimer = setTimeout(this.clockIntroUpdate, 100);
		this.flashUpdate();
	}

	updateTime() {
		let current = new Date().toUTCString();
		const timeLdn = moment.tz(current, 'Europe/London').format('HH:mm');
		const timeLA = moment.tz(current, 'America/Los_Angeles').format('HH:mm');
		const ldn = timeLdn.split(':');
		const la = timeLA.split(':');
		if (ldn[0] !== this.state.ldn[0] || ldn[1] !== this.state.ldn[1]) {
			this.setState({ ldn });
		}
		if (la[0] !== this.state.la[0] || la[1] !== this.state.la[1]) {
			this.setState({ la });
		}
		this.timeTimer = setTimeout(this.updateTime, 1000);
	}

	clockIntroUpdate() {
		clearTimeout(this.clockIntroTimer);
		if (this.state.clockIntro < 24) {
			this.setState({ clockIntro: this.state.clockIntro + 1 });
			this.clockIntroTimer = setTimeout(this.clockIntroUpdate, 50);
		}
	}

	flashUpdate() {
		clearTimeout(this.flashTimer);
		this.setState({ flash: !this.state.flash });
		this.flashTimer = setTimeout(this.flashUpdate, 500);
	}

	getClockDash(hr, min) {
		let dash = (hr * 2)%24;
		if (min >= 30) {
			dash += 1;
		}
		return dash;
	}

	drawClock() {
		let ctx = this.ctx;
		if (!ctx) {
			return;
		}
		let radius = this.radius;
		this.toggle = !this.toggle;
		let count = this.state.clockIntro;
		ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
		ctx.save();
		ctx.translate(ctx.canvas.width * .5, ctx.canvas.height * .5);
		let londonDash = this.getClockDash(+this.state.ldn[0], +this.state.ldn[1]);
		let laDash = this.getClockDash(+this.state.la[0], +this.state.la[1]);
		const isLondonNight = +this.state.ldn[0] < 8 || +this.state.ldn[0] >= 20;
		const isLaNight = +this.state.la[0] < 8 || +this.state.la[0] >= 20;

		for (let i = 0; i < count; i++) {
			ctx.fillStyle = 'rgba(255, 255, 255, 0.5)';
			ctx.imageSmoothingEnabled = true;
			if (i === londonDash && !this.state.flash) {
				let londonOpacity = isLondonNight ? 0.3 : 1;
				// green
				ctx.fillStyle = `rgba(52, 220, 134, ${londonOpacity})`;
				ctx.fillRect(-0.75, -radius, 2, 10);
			}
			if (i === laDash && !this.state.flash) {
				let laOpacity = isLaNight ? 0.3 : 1;
				// purple
				ctx.fillStyle = `rgba(130, 86, 232, ${laOpacity})`;
				ctx.fillRect(-0.75, -radius, 2, 10);
			}
			let isCityTime = i === londonDash || i === laDash;
			let shouldDisplay = !this.state.flash || count < 24;
			if (!isCityTime || (isCityTime && shouldDisplay)) {
				ctx.fillRect(-0.5, -radius, 1, 9);
			}
			ctx.rotate(Math.PI / 12);
		}
		ctx.restore();
	}

	renderTime(type, time, copy) {
		const isDesktop = this.props.isDesktop;
		const hour = +time[0];
		const isNight = hour < 8 || hour >= 20;
		return (
			<div class={joinClasses(s.office, s[type], this.props.active && s.active, isNight && s.night)} key={type}>
				<h3 class={joinClasses(s.region, isDesktop ? 'title' : 'large')}>
					<div class={s.cityLine} />
					<span class={s.cityName}>{copy.name}</span>
					<span class={s.localTime}>
						<span class={s.hours}>{time[0]}</span>
						<span class={s.colon}>:</span>
						<span class={s.minutes}>{time[1]}</span>
					</span>
				</h3>
				<div class={s.contact}>
					<Link class={joinClasses(s.phone, 'small')}>
						{copy.phone}
					</Link>
				</div>
			</div>
		);
	}

	render({ contactCopy }, { ldn, la }) {
		return (
			<div class={s.time} ref={ref => this.$time =ref}>
				<canvas
					class={s.clock}
					width={477}
					ref={ref => this.$canvas = ref}
				/>
				<div class={s.offices}>
					{this.renderTime('ldn', ldn, contactCopy.ldn)}
					{this.renderTime('la', la, contactCopy.la)}
				</div>
			</div>
		);
	}
}
